<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (model) {
    @if (workflowBlocked) {
        <div class="detail-page-action-bar action-bar-header flex-action-bar">
            <div class="error-message">
                {{ "controlTestplanBlockedMessage" | t }}
            </div>
        </div>
    } @else {
        <div class="detail-page-action-bar flex-action-bar">
            <div>
                @if (permissions?.canEdit || permissions?.canEditDocumentsAndHyperlinks) {
                    <!-- Every button of the action bar reads formGroup, which exists only after the standing data loads. -->
                    <button
                        data-uiid="button-savetask"
                        class="btn btn-cerrix"
                        [disabled]="!formGroup"
                        (click)="save()"
                    >
                        <i class="fas fa-save"></i>
                        <span class="d-none d-lg-inline">{{ "saveTaskButton" | t }}</span>
                    </button>
                }
            </div>
            <!-- workflow -->
            @if (model.id > 0) {
                <div class="workflow-area">
                    <span class="workflow-description">
                        {{ "statusLabel" | t }}
                        <b data-uiid="task-workflow-status">{{ model.workflowStateDescription }}</b>
                    </span>
                    @switch (model.workflowState) {
                        @case (TaskWorkflowStatus.ToDo) {
                            @if (id && permissions.canExecuteTask) {
                                <button
                                    type="button"
                                    (click)="toDoFinished()"
                                    class="btn btn-success"
                                    id="positive"
                                    data-uiid="task-mark-done-button"
                                    [disabled]="!formGroup"
                                >
                                    {{
                                        (isReviewEnabled
                                            ? "readyForReviewButton"
                                            : "markAsDoneButton"
                                        ) | t
                                    }}
                                </button>
                            }
                        }
                        @case (TaskWorkflowStatus.ReadyForReview) {
                            @if (permissions.canReviewTask) {
                                <button
                                    type="button"
                                    (click)="reviewRejected()"
                                    class="btn btn-dark"
                                    data-uiid="task-reviewer-reject-button"
                                    [disabled]="!formGroup"
                                >
                                    {{ "rejectButton" | t }}
                                </button>
                                <button
                                    type="button"
                                    (click)="reviewAccepted()"
                                    class="btn btn-success"
                                    data-uiid="task-reviewer-accept-button"
                                    [disabled]="!formGroup"
                                >
                                    {{ "acceptButton" | t }}
                                </button>
                            }
                        }
                        @case (TaskWorkflowStatus.Done) {
                            @if (permissions.canReopenTask) {
                                <button
                                    type="button"
                                    (click)="reopen()"
                                    class="btn btn-dark"
                                    id="negative"
                                    data-uiid="task-reopen-button"
                                    [disabled]="!formGroup"
                                >
                                    {{ "reopenButton" | t }}
                                </button>
                            }
                        }
                    }
                </div>
            }
        </div>
    }
}

@if (formGroup) {
    <div
        class="task-screen-system"
        menuSystem
        [cerrixTab]="tab"
        (changeEvent)="handleMenuItemClick($event)"
    >
        <div
            class="task-screens"
            menuItemId="menuTask"
            [attr.name]="'taskTab' | t"
            menuicon="fa-fw fa-list-ol far"
            menusystemsubmenu
        >
            <div
                menuItemId="menuDetails"
                [attr.name]="'details' | t"
                menuicon="fas fa-info-circle"
                menusystemitem
            >
                <task-detail-main
                    [model]="model"
                    [cerrixTab]="tab"
                    [permissions]="permissions"
                    [formGroup]="formGroup"
                    [showLinkedControls]="showLinkedControls"
                    [isReviewEnabled]="isReviewEnabled"
                    [standingData]="standingData"
                    #detailMain
                >
                </task-detail-main>
            </div>

            @if (isInitialized && id && permissions) {
                <div
                    class="task-screens"
                    [attr.menuItemId]="'menuLinks'"
                    [attr.name]="'links' | t"
                    menuicon="fas fa-link"
                    menusystemsubmenu
                >
                    @if (permissions.canViewLinkedControls) {
                        <div
                            menuItemId="menuItemControls"
                            [attr.name]="'controls' | t"
                            menuicon="fas fa-shield-alt"
                            menusystemitem
                        >
                            <!-- control linking disabled for now -->
                            <task-controls
                                [model]="model"
                                [disabled]="
                                    true ||
                                    !permissions.canEdit ||
                                    model.workflowState == TaskWorkflowStatus.Done
                                "
                                #linkedControls
                            ></task-controls>
                        </div>
                    }
                    @if (model.includedInTestplan && permissions.canViewLinkedEffectiveness) {
                        <div
                            menuItemId="menuItemEffectiveness"
                            [attr.name]="'testPlansTab' | t"
                            menuicon="fas fa-shield-alt"
                            menusystemitem
                        >
                            <task-effectiveness [id]="id"> </task-effectiveness>
                        </div>
                    }
                    @if (permissions.canViewDocumentsAndHyperlinks) {
                        <div
                            menuItemId="menuItemDocuments"
                            [attr.name]="'documents' | t"
                            menuicon="far fa-file"
                            menusystemitem
                        >
                            @if (documents) {
                                <div>
                                    <document-manager-old
                                        [(Documents)]="model.Documents"
                                        (DocumentsChange)="checkDocumentsDirty()"
                                        [permissions]="permissions.documentPermissions"
                                        [DocumentTypeTargets]="targetModule"
                                    >
                                    </document-manager-old>
                                </div>
                            } @else {
                                <div>
                                    <div class="fancy-loader"></div>
                                </div>
                            }
                        </div>
                        <div
                            menuItemId="menuItemHyperlinks"
                            [attr.name]="'hyperlinks' | t"
                            menuicon="fas fa-external-link-alt"
                            menusystemitem
                        >
                            @if (hyperlinksLoaded) {
                                <div>
                                    <hyperlink-manager
                                        [Hyperlinks]="model.hyperlinks"
                                        (HyperlinksChanged)="checkHyperlinksDirty()"
                                        [TargetModule]="targetModule"
                                        [Readonly]="!permissions.canEditDocumentsAndHyperlinks"
                                    ></hyperlink-manager>
                                </div>
                            } @else {
                                <div>
                                    <div class="fancy-loader"></div>
                                </div>
                            }
                        </div>
                    }
                </div>
            }
            @if (model.id > 0) {
                <div
                    [attr.name]="'historyTab' | t"
                    menuicon="fas fa-history"
                    menusystemitem
                    menuItemId="history"
                >
                    <app-history-overview
                        [historyDataService]="_ds"
                        [Id]="id"
                        #historyOverviewComponent
                    >
                    </app-history-overview>
                </div>
            }
            @if (id) {
                <div
                    [attr.name]="'options' | t"
                    menuItemId="menuItemOptions"
                    menuicon="fas fa-check-double"
                    menusystemitem
                >
                    <detail-options
                        moduleName="task"
                        [objectName]="model ? model.name : 'task'"
                        [allowDelete]="permissions.canDelete && !model.includedInTestplan"
                        (onDelete)="delete()"
                    >
                    </detail-options>
                </div>
            }
        </div>
    </div>
}
